'use client'

import { RefObject } from 'react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { AtButton, NavArrowLeft, NavArrowRight } from '../../atoms'
import { AtButtonDimensions, AtButtonTypes } from '../../types'
import type { Image } from '../ml-images'

export type SwiperEngineProps = {
  swiperRef: RefObject<SwiperRef | null>
  images: Image[]
  beginning: boolean
  end: boolean
  onBeginningChange: (beginning: boolean) => void
  onEndChange: (end: boolean) => void
}

export const SwiperEngine = ({
  swiperRef,
  images,
  beginning,
  end,
  onBeginningChange,
  onEndChange,
}: SwiperEngineProps) => (
  <Swiper
    ref={swiperRef}
    modules={[Pagination]}
    pagination={{
      dynamicBullets: true,
      dynamicMainBullets: 4,
    }}
    onSlideChange={(swiper) => {
      onEndChange(swiper.isEnd)
      onBeginningChange(swiper.isBeginning)
    }}
    className="w-full h-40"
  >
    <div className="absolute top-1/2 -translate-y-1/2 z-[2] left-6">
      <AtButton
        ariaLabel="Previous slide"
        className="w-10"
        type={AtButtonTypes.TERTIARY}
        isDisabled={beginning}
        size={AtButtonDimensions.SMALL}
        onClick={() => swiperRef.current?.swiper.slidePrev()}
        IconLeftRef={NavArrowLeft}
      />
    </div>
    <div className="absolute top-1/2 -translate-y-1/2 z-[2] left-full -translate-x-[calc(100%+1.5rem)]">
      <AtButton
        ariaLabel="Next slide"
        className="w-10"
        isDisabled={end}
        type={AtButtonTypes.TERTIARY}
        size={AtButtonDimensions.SMALL}
        onClick={() => swiperRef.current?.swiper.slideNext()}
        IconLeftRef={NavArrowRight}
      />
    </div>
    {images.map(({ alt, src, width, height }, i) => (
      <SwiperSlide key={i}>
        <img
          alt={alt}
          src={src}
          width={width}
          height={height}
          className="py-6 px-30 lg:px-[4.5rem] w-full h-full object-center"
          fetchPriority={i === 0 ? 'high' : 'auto'}
          loading={i === 0 ? 'eager' : 'lazy'}
        />
      </SwiperSlide>
    ))}
  </Swiper>
)
